import React from 'react';

const IconAdministration = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.73242 16.75C13.5984 16.75 16.7324 13.616 16.7324 9.75C16.7324 5.88401 13.5984 2.75 9.73242 2.75C5.86643 2.75 2.73242 5.88401 2.73242 9.75C2.73242 13.616 5.86643 16.75 9.73242 16.75Z"
      stroke="#111"
      strokeLinecap="round"
      strokeMiterlimit="16"
      strokeWidth="1.5"
    />
    <path
      d="M9.75391 11.75C10.8585 11.75 11.7539 10.8546 11.7539 9.75C11.7539 8.64543 10.8585 7.75 9.75391 7.75C8.64934 7.75 7.75391 8.64543 7.75391 9.75C7.75391 10.8546 8.64934 11.75 9.75391 11.75Z"
      stroke="#111"
      strokeLinecap="round"
      strokeMiterlimit="16"
      strokeWidth="1.5"
    />
    <path d="M9.73242 0.75L9.73242 2.75" stroke="#111" strokeLinecap="square" strokeWidth="1.5" />
    <path d="M15.5176 2.85559L14.232 4.38768" stroke="#111" strokeLinecap="square" strokeWidth="1.5" />
    <path d="M18.5957 8.18719L16.6261 8.53449" stroke="#111" strokeLinecap="square" strokeWidth="1.5" />
    <path d="M17.5273 14.25L15.7953 13.25" stroke="#111" strokeLinecap="square" strokeWidth="1.5" />
    <path d="M12.8105 18.2072L12.1265 16.3278" stroke="#111" strokeLinecap="square" strokeWidth="1.5" />
    <path d="M6.6543 18.2072L7.33834 16.3278" stroke="#111" strokeLinecap="square" strokeWidth="1.5" />
    <path d="M1.9375 14.25L3.66955 13.25" stroke="#111" strokeLinecap="square" strokeWidth="1.5" />
    <path d="M0.869141 8.18719L2.83876 8.53449" stroke="#111" strokeLinecap="square" strokeWidth="1.5" />
    <path d="M3.94727 2.85559L5.23284 4.38768" stroke="#111" strokeLinecap="square" strokeWidth="1.5" />
    <path d="M8.42969 8.22382L5.21575 4.39359" stroke="#111" strokeLinecap="round" strokeWidth="1.5" />
    <path d="M11.7266 9.4234L16.6506 8.55516" stroke="#111" strokeLinecap="round" strokeWidth="1.5" />
    <path d="M9.03906 11.6779L7.32896 16.3764" stroke="#111" strokeLinecap="round" strokeWidth="1.5" />
  </svg>
);

export default IconAdministration;
